package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class UpdateAudiobookEpisodeRequest(
    val title: String? = null,
    val description: String? = null,
    val episodeNumber: Int? = null,
    val durationSeconds: Int? = null
)
